export const fromServerErrors = (data) => {
    /*
        Input:
            {
                message: "Some general optional message",
                errors: [
                    {
                        field: "fieldname",
                        message: ["error A", "error B"]
                    },
                    ...
                ]
            }
        Output:
            {
                fieldname: ["error A", "error B"]
            }
    */
    if (!data || !data.errors) { return data; }
    const d = {};
    data.errors.forEach(e => {
        if (!e.field) { return; }
        if (!d[e.field]) { d[e.field] = []; }
        if (e.message && e.message.constructor === Array) {
            e.message.forEach(m => d[e.field].push(m));
        } else if (e.message != null && e.message !== '') {
            d[e.field].push(e.message);
        }
    });
    return d;
}

// The data provider resolves 4xx/5xx responses with their body instead of rejecting
// (api/dataProvider.js convertHttpResponse), so callers must check before using res.data:
// a refused save used to report success and cache the error body as the record (CP-8424).
export const isOk = (res) => !!res && !(res.statusCode >= 400);

// The backend's own words for a refused request: `message` (validation_error_to_response
// sends "" alongside field `errors`), DRF's `detail`, else the field errors joined.
export const serverErrorMessage = (res, fallback) => {
    const data = res?.data;
    const fieldMessages = Array.isArray(data?.errors)
        ? data.errors.flatMap((e) => (Array.isArray(e?.message) ? e.message : [e?.message])).filter(Boolean)
        : [];
    return data?.message || data?.detail || fieldMessages.join('; ') || fallback;
}

export const ensureOk = (res, fallback) => {
    if (!isOk(res)) {
        throw new Error(serverErrorMessage(res, fallback));
    }
    return res;
}

export const muiErrorAttrs = (id, errors, noMessage) => {
    const d = {};
    if (errors && errors[id]) {
        d.error = true;
        if (!noMessage) {
            d.helperText = errors[id].constructor === Array ? errors[id].join(', ') : errors[id];
        }
    }
    return d;
}

export const clearError = (id, errors) => {
    if (!errors || !errors[id]) {return errors; }
    const d = {...errors};
    delete d[id];
    return d;
}

class ValidationResult {
    constructor(is_valid, errors) {
        this.is_valid = is_valid;
        this.errors = errors;
    }
    muiAttrs(id, noMessage) {
        const d = {};
        if (this.hasError(id)) {
            d.error = true;
            if (!noMessage) {
                d.helperText = this.errorText(id)
            }
        }
        console.log('muiAttrs', id, this.hasError(id), this.errorText(id), d);
        return d;    
    }
    errorText(id) {
        if (!this.errors || !this.errors[id]) { return null; }
        return this.errors[id].constructor === Array ? this.errors[id].join(', ') : this.errors[id];
    }
    hasError(id) {
        return !!(this.errors && this.errors[id]);
    }
}

export const validate = (rec, serverErrors, fn) => {
    const errors = serverErrors ? {...serverErrors} : {};
    let canSave = !serverErrors;
    // console.log('validate:serverErrors', serverErrors, !!serverErrors, canSave);
    if (fn) {
        const _res = fn(rec);
        // console.log('validate:after fn', _res);
        if (!_res.canSave) {
            canSave = _res.canSave;
        }
        Object.keys(_res.errors || []).forEach(e => {
            if (!errors[e]) { errors[e] = []; }
            errors[e] = errors[e].concat(e);
        });
    }
    console.log('validate:result', canSave, errors);
    return new ValidationResult(canSave, errors);
}
